export default __webpack_public_path__ + "static/media/VIP_blue.9b30fbd6.png";